import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import { Icon, Typography } from "../../index";
import './dropdown.scss';

export const DropDownHintMsg = ({
    colorStyle = 'neutral',
    hintMsg,
}) => {

    const stateStyle = {
        error: {
            iconName: 'exclamation',
            iconColor: '$color-system-b1',
            msgColor: '$color-system-b1',
        },
        neutral: {
            iconName: '',
            iconColor: '',
            msgColor: '$color-secondary-a2',
        },
        success: {
            iconName: 'check',
            iconColor: '$color-system-a1',
            msgColor: '$color-system-a1',
        },
    };

    return (<div className="bsw-dropdown__hint">
            {(colorStyle !== 'neutral') &&
                <div className="bsw-dropdown__validation-icon">
                    <Icon
                    name={stateStyle[colorStyle]['iconName']}
                    color={stateStyle[colorStyle]['iconColor']}
                        size="small"
                    />
                </div>
            }
            <Typography type="meta-01" color={stateStyle[colorStyle]['msgColor']}>
                {hintMsg}
            </Typography>
        </div>)
}

DropDownHintMsg.propTypes = {
    colorStyle: PropTypes.string,
    hintMsg: PropTypes.string,
}